/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable no-restricted-globals */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * 具有记录路由关系与回跳功能
 * 配合vue-router 3.0.1使用，必须要支持pushstate
 * 原理为记录vue-router跳转时state的状态
 */
import _ from 'lodash';

import router from '@/router';
import { getHomePath } from '@/router/utils';
import { isH5App } from '@/constant';
import { closeWebView, skBackHome } from '@/api/native/utils';
import store from '@/store';
import wechat, { isFinanceWechatMini } from '@/api/native/wechat';
import {
  changeTabbarMaskStatus, changeTabbarShowStatus,
  skNativeContainer, skNativeContainerOpen, skToTabbarPage,
} from '@/api/native/container';
import { RouterV2Enum, RouterV3Enum } from '@/router/router-names';
import { jumpToMarketPage } from '../jumpToRedirectPage';
import platform from '../platform';
import { jumpFromWalletTab } from '../jumpTo';
import { getTabIdByPath } from '../getTabIdByPath/getTabIdByPath';

const historyStates: { key: string; paths: string[] }[] = []; // 当前浏览的state历史栈
let lastPopstate = { key: undefined };
/** 上一页面的路由path */
let lastRoutePath = '';
/** 当前的state */
let currentState: { key: string; paths: string[] } = { key: '', paths: [] };
let helperBacking: boolean | string = false; // 返回到特定页面时用的路径，用来replace使用
let backConfirmConfig: any | 'default' | false = 'default'; // 配置的返回确认，会覆盖mata的
let backPathConfig: 'default' | false | string = 'default'; // 配置的返回路径，会覆盖meta的

/** 判断是否为首页路径，兼容v2、v3 */
const isHomePath = (path: string) => (path === getHomePath() || path === RouterV3Enum.home);

export default class RouterHelper {
  static isBackOnce() {
    const result = lastPopstate.key
      && _.findIndex(historyStates, { key: lastPopstate.key }) !== -1;
    lastPopstate = { key: undefined };
    return result && !store.state.base.backByJumpToNew;
  }

  /** 页面内beforeRouteLeave调用不会导致router.beforeEach中isBackOnce失效 */
  static isBack() {
    const result = lastPopstate.key
      && _.findIndex(historyStates, { key: lastPopstate.key }) !== -1;
    return result && !store.state.base.backByJumpToNew;
  }

  static resetLastPopState() {
    lastPopstate = { key: undefined };
  }

  static get HelperBacking() {
    return helperBacking;
  }

  // 页面返回时，校正historyStates
  static backFix() {
    if (!history.state) return;
    helperBacking = false;
    const index = _.findIndex(historyStates, { key: history.state.key });
    if (index !== -1) {
      historyStates.splice(index - historyStates.length);
      RouterHelper.abandonCurr();
    }
  }

  private static abandonCurr() {
    currentState.key = '';
  }

  // 页面稳定时，维护historyStates
  private static settle() {
    if (!currentState.key) return;
    const index = _.findIndex(historyStates, { key: currentState.key });
    if (index === -1) {
      historyStates.push(currentState);
    }
  }

  static updateCurrentState(path: string, siblingPaths?: string[]) {
    /** 更新上一页面的路由path */
    lastRoutePath = Array.isArray(currentState.paths)
      ? currentState.paths[currentState.paths.length - 1] : '';

    if (!history.state) return;
    if (history.state.key === currentState.key) {
      // 保证当前访问的路径按照访问时间保存在最顶层
      if (_.includes(currentState.paths, path)) {
        currentState.paths.splice(currentState.paths.indexOf(path), 1);
      }
      currentState.paths.push(path);
    } else {
      RouterHelper.settle();

      currentState = {
        key: history.state.key,
        // 确保在返回backHome的时候能够找到对应的historyStateKey
        paths: !siblingPaths
          ? [path]
          : siblingPaths.reduce(
            (result, item) => {
              if (!_.includes(result, item)) {
                result.splice(result.length - 1, 0, item);
              }
              return result;
            },
            [path],
          ),
      };
    }
  }

  static useNextFalse(next: any) {
    next(false);
    currentState.key = history.state ? history.state.key : '';
  }

  /** 处理tabbar 是否显示 隐藏 */
  static tabbarStatusHandler(path: string) {
    if (
      path.includes(RouterV2Enum.myProfile)
      || path.includes(RouterV2Enum.home)
      || path.includes(RouterV2Enum.taglessHome)
      || path.includes(RouterV2Enum.qualityHomePage)
      || path.includes(RouterV3Enum.home)
    ) {
      /** 不能await 会空白 */
      changeTabbarShowStatus(true);
    } else {
      changeTabbarShowStatus(false);
      /** 切换至无tabbar页面时，兜底处理：隐藏容器化TabBar遮罩 */
      changeTabbarMaskStatus({
        show: false,
        duration: 100,
        tabId: getTabIdByPath(),
      });
    }
  }

  static useNext(next: any, to: any, from: any) {
    const backPath = RouterHelper.HelperBacking;
    RouterHelper.backFix();
    RouterHelper.setBackConfirm();
    RouterHelper.setBackPath();

    if (_.isString(backPath) && !_.includes(to.fullPath, backPath)) {
      next({ path: backPath, replace: true });
    } else {
      if (to.fullPath === '/' && platform.isSkApp) {
        next(false);
        RouterHelper.backHome();
      }
      jumpFromWalletTab(next, to, from);
      // next();
    }


    /** 老项目内 路由正常跳转，没有被拦截的场景，显示和隐藏 native tabbar */
    RouterHelper.tabbarStatusHandler(to.path);
    // 执行完回跳后将页面回回跳状态置false
    if (store.state && store.state.base && store.state.base.backByJumpToNew) {
      store.state.base.backByJumpToNew = false;
    }
  }

  // 回跳到访问过的路由，
  // replacePath: 回跳到页面后，如果页面路径与replacePath不一致，则replace到该页面
  // backToPath(routerEnum.home, `{routerEnum.myProfile}?param=xx`)
  static backToPath(path: string, replacePath?: string) {
    // TODO: 待处理 页面刷新后,historyStates 为空的场景，页面无法回退
    // TODO: 链接上携带source怎么办
    helperBacking = path;
    const backPathIndex = _.findLastIndex(
      historyStates,
      ({ paths }) => _.some(paths,
        (item) => _.isEqual(item, path) || _.isEqual(item.split('?')[0], path)),
      // _.includes(item, path) =>
      // _.isEqual(item, path) || _.isEqual([item, item.split('?')[0]], path))
      // 既解决 精准匹配目标跳转路由问题 也要解决链接有？的场景
    );
    if (backPathIndex !== -1) {
      const goStep = backPathIndex - historyStates.length;
      helperBacking = replacePath || helperBacking;

      // 防止在首页退出应用；
      if (window.location.hash.indexOf('home') > -1 && isHomePath(path)) {
        RouterHelper.tabbarStatusHandler(path);
        // 回跳执行完后，清楚当前的helperback地址，防止二次执行；
        helperBacking = '';
      } else {
        router.go(goStep);
      }
      return true;
    }


    // h5场景 没访问过首页的情况下，回退的时候，跳到落地页去
    if (isH5App && isHomePath(path)) {
      jumpToMarketPage();
      return true;
    }

    return false;
  }

  static async backHome() {
    if (await skNativeContainer()) {
      /** 回到首页tab */
      skToTabbarPage(
        {
          tabId: 'home',
        },
      );
      return window.history.go(-(window.history.length - 1));
    }


    // 修复如果当前没有历史访问列表，跳转首页出错；
    return RouterHelper.navigate(getHomePath());
  }

  // 访问路由，如果访问过则回跳，否则push
  static async navigate(path: string) {
    if (await skNativeContainer() && isHomePath(path) && platform.isAndroid) {
      /** 回到首页tab */
      skToTabbarPage(
        {
          tabId: 'home',
        },
      );
      return;
    }

    // app场景，回到首页：关闭webview
    if (platform.isSkApp && isHomePath(path)) {
      skBackHome();
      return;
    }

    // 小程序场景，回到首页：返回小程序的上一级页面
    if (isFinanceWechatMini() && isHomePath(path)) {
      wechat.backToHome();
      return;
    }
    if (platform.isEasyBike && store.state.base.isHybridAppMode && isHomePath(path)) {
      window.location.href = 'hellobike://hellobike.com/wallet?index=1';
      return;
    }

    RouterHelper.tabbarStatusHandler(path);

    if (!RouterHelper.backToPath(path)) {
      // TODO:参数透传
      // const queryArr = window.location.href.split('?');
      // const queryStr = queryArr.length >= 2 ? queryArr[1] : '';
      // router.push(`${path}${queryStr ? `?${queryStr}` : ''}`);
      router.push(path);
    }
  }

  /** 判断目标path页面是否在访问历史记录(historyStates)的上一页面 */
  static isPreviousPage(routeNames: string | string[]) {
    const historyPreviousState = _.last(historyStates);

    if (historyPreviousState) {
      const { paths: previousPaths } = historyPreviousState;

      if (_.isArray(routeNames)) {
        /** historyStates[x].paths数据格式如下: ['/v2/home', '/v2/home?source=xx'] */
        return _.some(
          routeNames,
          (routeName) => _.some(
            previousPaths,
            (previousPath) => _.startsWith(previousPath, routeName),
          ),
        );
      }

      return _.some(previousPaths, (previousPath) => _.startsWith(previousPath, routeNames));
    }

    return false;
  }

  /**
   * 判断目标路由是否为上一页面(与history记录栈无关)
   * @param routeName 目标路由
   */
  static isLastPageRoute(routeName: string) {
    if (typeof lastRoutePath === 'string') {
      return lastRoutePath.startsWith(routeName);
    }

    return false;
  }

  // config：false表示取消返回时确认，default表示使用router默认配置
  static setBackConfirm(config: any = 'default') {
    backConfirmConfig = config;
  }

  // config：设置返回时的路径，default表示使用router默认配置
  static setBackPath(config: any = 'default') {
    backPathConfig = config;
  }

  static get backConfirmConfig() {
    return backConfirmConfig;
  }

  static get backPathConfig() {
    return backPathConfig;
  }

  // 提供对外访问historyStates的方法，方便动态判断页面应该返回的路由
  static get historyStates() {
    return historyStates;
  }
}

window.addEventListener('popstate', ({ state }) => {
  lastPopstate = state && state.key ? state : lastPopstate;
});
